



















import {Component, Prop, Vue} from "vue-property-decorator";
import click2Top from "@/common/directives/click2Top";
import Company from "@/model/company";
@Component({
  name: "CompanyCooperationList",
  directives: {
    click2Top,
  },
})
export default class CompanyCooperationList extends Vue {
  @Prop({
    default: () => {
      return [];
    },
  })
  mcCooperateList: Company[];
}
